import { CdnImage } from "@trueskin-web/components"

const PlanImage = ({ image, title, className }) => (
  <CdnImage
    src={image}
    alt={title}
    sx={{
      mt: [2, 0],
      mb: [0, 4],
      width: "100%",
      borderRadius: "8px",
    }}
    data-testid="web-portal-plan-selection-plan-image"
    className={className}
  />
)

export default PlanImage
